// import {Formula} from "./stores/AnimationStore";

export function buildFormula(definition: string): Function {
    // console.log("buildFormula", definition);
    let callback: Function;
    try {
        /* eslint-disable no-new-func */
        callback = new Function('x', 'y', 't', 'i', 's', 'r', `
            try {
                with (Math) {
                    return ${definition.replace(/\\/g, ';')};
                }
            } catch (error) {
                return error;
            }
        `);
        // console.log(callback);
    } catch (error) {
        callback = () => 0;
    }
    return callback;
}
